enum IconNameEnum {
    Aggiorna = "cq_aggiorna",
    AggiornaDati = "cq_aggiorna_dati",
    Aggiungi = "cq_aggiungi",
    Alert = "cq_alert",
    AlertRosso = "cq_alert_red",
    AllegaDocumento = "cq_allega_documento",
    Allegato = "cq_allegato",
    AltroMenu = "cq_altro_menu",
    AndamentoFinanziamenti = "cq_andamento_finanziamenti",
    ApriBlu = "cq_apri_blu",
    Avanti = "cq_avanti",
    Calcola = "cq_calcola",
    Calendario = "cq_calendario_grigio",
    CalendarioPlus = "cq_calendario_plus",
    Carica = "cq_carica",
    CassettoDigitale = "cq_cassetto_digitale",
    Cellulare = "cq_cellulare",
    Cerca = "cq_cerca",
    CercaBlu = "cq_cerca_blu",
    ConfermaSalva = "cq_conferma_salva",
    ContrassegnaElemento1 = "cq_contrassegna_elemento1",
    ContrassegnaElemento2 = "cq_contrassegna_elemento2",
    Convalida = "cq_convalida",
    Corsivo = "cq_corsivo",
    Documenti = "cq_documenti",
    Documento = "cq_documento",
    DocumentoFirma = "cq_firma_documento",
    DocumentoInoltra = "cq_inoltra_documento",
    DocumentoLetto = "cq_documento_letto",
    DocumentoModifica = "cq_modifica_documento",
    DocumentoNuovo = "cq_nuovo_documento",
    DocumentoVisualizza = "cq_visualizza_documento",
    DopoIlFinanziamento = "cq_dopo_il_finanziamento",
    Elimina = "cq_elimina",
    EliminaBlu = "cq_elimina_blu",
    Elenco = "cq_elenco",
    Esporta = "cq_esporta",
    Euro = "cq_euro",
    ColonnaOrdineDefault = "cq_ordinamento_def",
    ColonnaOrdineAsc = "cq_ordinamento_asc",
    ColonnaOrdineDesc = "cq_ordinamento_desc",
    FileExcel = "cq_file_exel",
    FileExcelBianco = "cq_file_exel_b",
    FileExcelExport = "cq_file_export",
    FrecciaDestraBianco = "cq_freccia_destra_b",
    FrecciaDestraBlu = "cq_freccia_destra_blu",
    Flag = "cq_flag",
    GraficoTorta = "cq_grafico_torta",
    Grassetto = "cq_grassetto",
    Home = "cq_home",
    Imbuto = "cq_imbuto",
    Indietro = "cq_indietro",
    IndietroBianco = "cq_indietro",
    Info = "cq_info",
    Inoltra = "cq_inoltra",
    Ko = "cq_ko",
    Login = "cq_login",
    Logout = "cq_logout",
    Locazione = "cq_locazione",
    Mail = "cq_mail",
    MessaggiSegnaLetti = "cq_messaggi_segna_tutti_come_letti",
    Messaggio = "cq_messaggi",
    MessaggioBozza = "cq_bozza_messaggio",
    MessaggioCrea = "cq_nuovo_messaggio",
    MessaggioInviato = "cq_invia_messaggio",
    MessaggioLetto = "cq_messaggio_letto",
    MessaggioNuovo = "cq_nuovo_messaggio_ricevuto",
    MessaggioRicevuto = "cq_ricevi_messaggio",
    Montante = "cq_montante",
    Mostra = "cq_mostra",
    MenuApri = "cq_freccia_giu",
    MenuChiudi = "cq_freccia_su",
    MenuComprimi = "cq_freccia_sinistra",
    MenuEspandi = "cq_freccia_destra",
    MenuEspandiBianco = "cq_freccia_destra_b",
    MenoBianco = "cq_meno_b",
    MinusBianco = "cq_minus_b",
    Minus = "cq_minus",
    ModificaDati = "cq_modifica_dati",
    ModificaDatiBianco = "cq_modifica_dati_b",
    ModificaDatiBlu = "cq_modifica_dati_blu",
    ModificaBlu = "cq_modifica_blu",
    Nascondi = "cq_nascondi",
    Notifiche = "cq_notifiche",
    NuovoAppuntamento = "cq_nuovo_appuntamento",
    NuovoAppuntamentoBlu = "cq_nuovo_appuntamento_blu",
    Ok = "cq_ok",
    Orologio = "cq_orologio",
    Pagamenti = "cq_pagamenti",
    PeriodoOggi = "cq_oggi",
    PeriodoOggiOption = "cq_oggi_option",
    PeriodoTutti = "cq_tutti",
    PeriodoTuttiOption = "cq_tutti_option",
    PeriodoUltimaSettimana = "cq_ultima_settimana",
    PeriodoUltimaSettimanaOption = "cq_ultima_settimana_option",
    PeriodoUltimoMese = "cq_ultimo_mese",
    PeriodoUltimoMeseOption = "cq_ultimo_mese_option",
    PeriodoOrdineAsc = "cq_ordine_tempo1",
    PeriodoOrdineDesc = "cq_ordine_tempo2",
    PlusBianco = "cq_plus_b",
    PiuBianco = "cq_piu_b",
    Plus = "cq_plus",
    Percentuale = "cq_percentuale",
    PercentualeBlue = "cq_percentuale_blu",
    Pratiche = "cq_pratiche",
    PrimaDelFinanziamento = "cq_prima_del_finanziamento",
    Richieste = "cq_richieste",
    RichiesteInCorso = "cq_richieste_in_corso",
    RichiesteScadute = "cq_richieste_scadute",
    Scarica = "cq_scarica",
    Scarica_PDF = "cq_scarica_pdf_rosso",
    Scarica_PDF_Nero = "cq_scarica_pdf_nero",
    Simulatore = "cq_simulatore",
    Simulazione = "cq_simulazione",
    Sinistri = "cq_sinistri",
    SinistriPratica = "cq_sinistri_collegati_pratica",
    Sottolineato = "cq_sottolineato",
    Stampa = "cq_stampa",
    Tabella = "cq_tabella",
    Telefono = "cq_tel_fisso",
    Utente = "cq_utente",
    Upload = "cq_upload_nero",
    UtenteBianco = "cq_utente",
    RicercaGrigio = "ricerca_grigio",
    EditorEvidenziato = "cq_editor_evidenziato",
    EditorIntestazione1 = "cq_editor_intestazione1",
    EditorIntestazione2 = "cq_editor_intestazione2",
    EditorIntestazione3 = "cq_editor_intestazione3",
    EditorIntestazione4 = "cq_editor_intestazione4",
    EditorIntestazione5 = "cq_editor_intestazione5",
    EditorIntestazione6 = "cq_editor_intestazione6",
    EditorListaNumerata = "cq_editor_lista_numerata",
    EditorListaPuntata = "cq_editor_lista_puntata",
    EditorSottolineato = "cq_editor_sottolineato",
    EditorTestoCentro = "cq_editor_testo_centro",
    EditorTestoDestra = "cq_editor_testo_destra",
    EditorTestoSinistra = "cq_editor_testo_sinistra",
    EsportaExcel = "cq_esporta_exel",
    Simulazioni = "cq_simulatore_blu_scuro",
    Preventivi = "cq_firma_documento_blu_scuro",
}

export default IconNameEnum;
